/** @file Generated Inspector forms per form kind, and the command that renames that kind (null: none). */

/** Attachments split into region and mesh; `project` is shown when nothing is selected (W3-41: no ik/event/skin/…). */
export const ENTITY_FORMS = {
  project: { forms: ['project.setFps', 'project.setView'], rename: null },
  bone: { forms: [], rename: 'bone.rename' },
  slot: { forms: ['slot.setColor', 'slot.setBlend', 'slot.setAttachment', 'slot.setBone'], rename: 'slot.rename' },
  region: { forms: ['attachment.setTransform', 'attachment.setImage', 'attachment.setHandle'], rename: 'attachment.rename' },
  mesh: { forms: ['attachment.setImage', 'attachment.setHandle', 'mesh.setBinding', 'mesh.setHull', 'mesh.smoothWeights', 'mesh.rebindMesh'], rename: 'attachment.rename' },
  image: { forms: [], rename: 'image.rename' },
} as const;
